import * as React from 'react';
import {Glyph} from '../../types/Glyph';
import {ReactNode, useMemo} from 'react';
import {ReactComponent as AcceptGlyph} from './glyphs/accept.svg';
import {ReactComponent as SaveGlyph} from './glyphs/save.svg';
import {ReactComponent as AddGlyph} from './glyphs/add.svg';
import {ReactComponent as CancelGlyph} from './glyphs/cancel.svg';
import {ReactComponent as BusyGlyph} from './glyphs/busy.svg';
import {ReactComponent as DeleteGlyph} from './glyphs/delete.svg';
import {ReactComponent as PasteGlyph} from './glyphs/paste.svg';
import {ReactComponent as DraggableGlyph} from './glyphs/draggable.svg';
import styles from './Icon.module.css';
import RenderHelpers from '../../../shared-ui/helpers/RenderHelpers';

export interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  glyph: Glyph | ReactNode;
  size?: number | string;
}

export const Icon = (props: IconProps) => {
  const contents = useMemo(
    () => {
      if (typeof props.glyph !== 'string') {
        return props.glyph;
      }

      switch (props.glyph) {
        case 'accept':
          return <AcceptGlyph/>;
        case 'save':
          return <SaveGlyph/>;
        case 'paste':
          return <PasteGlyph/>;
        case 'add':
          return <AddGlyph/>;
        case 'cancel':
          return <CancelGlyph/>;
        case 'delete':
          return <DeleteGlyph/>;
        case 'busy':
          return <BusyGlyph/>;
        case 'draggable':
          return <DraggableGlyph/>;
        default:
          return null;
      }
    },
    [props.glyph]
  );

  const isAnimated = props.glyph === 'busy';

  return (
    <div
      className={
        RenderHelpers.classes(
          styles.component,
          props.className,
          isAnimated ? styles.animated : null
        )
      }
      style={props.style}
    >
      {contents}
    </div>
  );
};